import NumberListFilter from "@search/store/filters/primitive/NumberListFilter";

class RegionFilter extends NumberListFilter {
  constructor(value: Array<string>) {
    super({ label: "region", name: "regionIds", value });
  }
}

export default RegionFilter;
export { RegionFilter };
